import React, { Component,Fragment } from 'react';
import banner_mengduo from './image/mengduo/teach.svg';
import slogan from './image/mengduo/tutorial_text.svg' ;
import logo_01 from './image/mengduo/logo-01.png';
import logo from './image/logo-toturial.png';
import noSelect from './image/mengduo/noselect.svg';
import selected from './image/mengduo/selected.svg';
import One from './image/mengduo/1.png';
import Two from './image/mengduo/2.png';
import Three from './image/mengduo/3.png';
import Four from './image/mengduo/4.png';
import Five from './image/mengduo/5.png';
import Five_mengduo from './image/mengduo/mengduo5.png';
import './config';
import './Tutorial.css';

export default class Tutorial extends Component {
    constructor(props){
        super(props)
        this.state={
            button_L:[{button:"01 前期准备"},{button:"02 扫描身份证登录"},{button:"03 录入身高体重"},{button:"04 拍摄正、侧面照片"},{button:"05 数据展示"}],
            button_R:[
                {button:"前期准备"},
                {button:"扫描身份证登录"},
                {button:"录入身高体重"},
                {button:"拍摄正、侧面照片"},
                {button:"数据展示"},
            ],
            num:0,
        }
    }
    change=(index)=>{
        console.log(index);
        
        this.setState({
            num:index
        },()=>{
             console.log(index);
            
        })
    }

  render(){
      return(
          <Fragment>
            <div className={global.constants.channel==="mengduo"? "banner_mengduo":"banner"}>
                <div className="banner--content">
                    <img src={slogan} alt="slogan" />
                    <img src={ banner_mengduo} alt="" />
                </div>
             </div>
             <div style={{display:"flex",marginTop:50,marginBottom:50}}>
                <div className="buttons">
                    {this.state.button_L.map((item,index)=>{
                        return(
                            <div className={index===this.state.num?"buttons--item_select":"buttons--item"} onClick={this.change.bind(this,index)}>
                                {item.button}
                            </div>
                        );
                    })}
                </div>
                <div >
                    <div className="toturial--tab">
                        <img src={global.constants.channel==="mengduo"?logo_01:logo} alt="" style={{width:107,height:30,marginLeft:20}}/>
                        <div className="toturial--title">
                            {this.state.button_R.map((item,index)=>{
                                return(
                                    <Fragment>
                                        <div className="toturial--title-item">
                                            <div className="toturial--title-text" >{item.button}</div>
                                            <img src={index===this.state.num?noSelect:selected} />
                                        </div>
                                    </Fragment>
                                )
                            })}
                        </div>
                        <div className="toturial--line"/>
                    </div>
                    <div className="toturial--img">
                        {this.state.num===0&&
                            <img className="toturial--img0" src={One} />
                        }
                        {this.state.num===1&&
                            <img className="toturial--img1" src={Two} />
                        }
                        {this.state.num===2&&
                            <img className="toturial--img2" src={Three} />
                        }
                        {this.state.num===3&&
                            <img className="toturial--img3" src={Four} />
                        }
                        {this.state.num===4&&global.constants.channel==="mengduo"&&
                            <img className="toturial--img4" src={Five_mengduo} />
                        }
                        {this.state.num===4&&global.constants.channel==="hongchuang"&&
                            <img className="toturial--img4" src={Five} />
                        }
                    </div>
                   
                </div>
            </div>
          </Fragment>
       
      )
  }
};



// WEBPACK FOOTER //
// ./src/Tutorial.js